import "../sass/newspage.scss";
const data = require("../data/updates-news.json");
import brImg from "../images/battle-royale.jpg";

var newsData = [];
var stickySideNavbarItems = "";
var newAccordionContainer = "";

(function mainScript() {
	"use strict";
	newsData = data["updates-news"];
	renderNews();
})();

function renderNews() {

	newAccordionContainer = `<div id='no-results' class='no-results'>No results</div>`;

	for (let i = 0; i < newsData.length; i++) {
		const newData = newsData[i];

		for (let j = 0; j < newData.months.length; j++) {
			const month = newData.months[j];

			if (
				$(window).width() < 991 &&
				newData.months.length === 1 &&
				month.weeks.length === 1
			) {
				$(".sticky-content").css("display", "none");
			} else {
				stickySideNavbarItems += `				
				<div class="form-group">
					<input id="${newData.year}-${convertToLowerCase(
					month.name
				)}-news-subtitle-input" type="radio" name='news'>
					<label for="${newData.year}-${convertToLowerCase(
					month.name
				)}-news-subtitle-input" id="${newData.year}-${convertToLowerCase(
					month.name
				)}-news-label-subtitle" class="bold-label">${month.shortName}, ${
					newData.year
				}</label><div id="${newData.year}-${convertToLowerCase(
					month.name
				)}-news-label-accordion-content" class="mobile-hidden-default">`;
			}

			for (let z = 0; z < month.weeks.length; z++) {
				const week = month.weeks[z];
				stickySideNavbarItems += `<div class="form-group week-group">
					<input id="${newData.year}-${convertToLowerCase(
					month.name
				)}-news-${convertToLowerCase(week.name).replace(
					" ",
					"-"
				)}-input" type="radio" name='news' ${i === 0 && j === 0 && z === 0 && "checked"}>
					<label for="${newData.year}-${convertToLowerCase(
					month.name
				)}-news-${convertToLowerCase(week.name).replace(" ", "-")}-input" id="${
					newData.year
				}-${convertToLowerCase(month.name)}-news-label-${convertToLowerCase(
					week.name
				).replace(" ", "-")}-clickable">${week.name}</label>
					</div>`;

				newAccordionContainer += `<div id="${newData.year}-${convertToLowerCase(
					month.name
				)}-news-div-${convertToLowerCase(week.name).replace(
					" ",
					"-"
				)}" class="mb-5"><h3 class="mb-3">${week.name}, ${month.shortName}, ${
					newData.year
				}</h3>`;

				for (let x = 0; x < week.news.length; x++) {
					const newInfo = week.news[x];
					const accId = "_" + Math.random().toString(36).substr(2, 9);

					newAccordionContainer += `
						<div class="accordion" id="${convertToLowerCase(newInfo.title)}-information">
							<div class="accordion-item">
								<h2 class="accordion-header" id="${accId}-panel-headingOne">
									<button class="accordion-button collapsed" type="button"
										data-bs-toggle="collapse" data-bs-target="#${accId}-panel-collapseOne"
										aria-expanded="true" aria-controls="${accId}-panel-collapseOne">
										<p class="accordion-btn-txt">${newInfo.title}</p>
									</button>
								</h2>
								<div id="${accId}-panel-collapseOne" class="accordion-collapse collapse"
									aria-labelledby="${accId}-panel-headingOne">
									<div class="accordion-body">`;

					for (let y = 0; y < newInfo.description.length; y++) {
						const descriptionText = newInfo.description[y];
						newAccordionContainer += `
							<p>${descriptionText.replace(/\n/g, "</br>")}</p>
						`;
					}

					newAccordionContainer += `</div>
							</div>
								</div>
									</div>`;
				}

				newAccordionContainer += `</div>`;
			}

			stickySideNavbarItems += `</div></div>`;
		}
	}

	let stickySideNavbar = $(".sticky-content");
	stickySideNavbar.html(stickySideNavbarItems);
	let newsContainer = $("#news");
	newsContainer.html(newAccordionContainer);
	setImages();
	filterByQuery();
}

function setImages() {
	$("#news")
		.find("img")
		.each(function (i) {
			if ($(this).attr("id") === "battle-royale-img") {
				$(this).attr("src", brImg);
			}
		});
}

function convertToLowerCase(value) {
	if (typeof value === "string") {
		return value.toLowerCase();
	}
}

function filterByQuery() {
	const urlSearchParams = new URLSearchParams(window.location.search);
	const searchQuery = Object.fromEntries(urlSearchParams.entries()).search;
	if (searchQuery) {
		$("#searchField").val(searchQuery);
		searchFilter(searchQuery);
	}
}

function searchFilter(value) {
	var searchValue = value || $("#searchField").val();
	searchValue = searchValue.toString().toLowerCase().replace(/'/g, "’");
	var mainDivContainers = [];
	$("#news > div").each(function (e) {
		var accordionsPerContainer = [];
		mainDivContainers.push(e);
		var mainDiv = $(this);
		$(this)
			.children("div")
			.each(function (el) {
				accordionsPerContainer.push(el);
				var accordionItem = $(this);
				$(this)
					.children("div")
					.each(function (ele) {
						var headerElementHasMatch =
							$(this)
								.children("h2")
								.children("button")
								.text()
								.toLowerCase()
								.indexOf(searchValue) > -1;
						var contentElementHasMatch =
							$(this)
								.children("div")
								.children("div")
								.children("p")
								.text()
								.toLowerCase()
								.indexOf(searchValue) > -1;

						if (!headerElementHasMatch && contentElementHasMatch) {
							accordionItem.css("display", "block");
						} else if (headerElementHasMatch && !contentElementHasMatch) {
							accordionItem.css("display", "block");
						} else if (!headerElementHasMatch && !contentElementHasMatch) {
							accordionItem.css("display", "none");
							accordionsPerContainer.pop();
						} else {
							accordionItem.css("display", "block");
						}
					});
			});
		if (accordionsPerContainer.length === 0) {
			mainDiv.css("display", "none");
			mainDivContainers.pop();
		} else {
			mainDiv.css("display", "block");
		}
	});
	if (mainDivContainers.length === 0) {
		$("#no-results").css("display", "block");
	} else {
		$("#no-results").css("display", "none");
	}
}

$(function () {
	$(".sticky-content .form-group label").each(function (i) {
		$(this).on("click", function (event) {
			var lblId = $(this).attr("id");
			var scrollValue;

			if (lblId.includes("-clickable")) {
				lblId = lblId.replace(/-label/g, "-div").replace(/-clickable/g, "");
				scrollValue = $("#" + lblId).offset().top;

				$(this).prev().prop("checked", true);

				$("html, body").animate(
					{
						scrollTop: scrollValue,
					},
					100
				);

				event.preventDefault();
			} else {
				var accordionItem = $(
					"#" +
						lblId.substr(0, lblId.indexOf("-", lblId.indexOf("-") + 1)) +
						"-news-label-accordion-content"
				);
				accordionItem.toggle();
			}
		});
	});
});

$(function () {
	$("#searchField").on("keyup", function () {
		searchFilter();
	});
});
